import { Component, OnInit } from '@angular/core';
import { SwiperModule } from 'swiper/angular';
import { LuckySlider1Component } from './lucky-slider1/lucky-slider1.component';
import { LuckySlider2Component } from './lucky-slider2/lucky-slider2.component';
import { LuckySlider3Component } from './lucky-slider3/lucky-slider3.component';

@Component({
    selector: 'app-lucky-slider-stepper',
    templateUrl: './lucky-slider-stepper.component.html',
    styleUrls: ['./lucky-slider-stepper.component.scss'],
    standalone: true,
    imports: [
        SwiperModule,
        LuckySlider1Component,
        LuckySlider2Component,
        LuckySlider3Component,
    ],
})
export class LuckySliderStepperComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
